import { jsxs as A, jsx as h } from "react/jsx-runtime";
import W, { useEffect as z, useState as N, useCallback as j, useRef as M } from "react";
const _ = {
  evergreen: "#00381D",
  green: "#CCFFD0",
  offBlack: "#1C1B1C",
  grayLight: "#EBEBE9"
}, V = ({ onRetry: e }) => A("div", { role: "alert", style: {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
  maxWidth: "360px",
  margin: "0 auto",
  padding: "32px 24px",
  textAlign: "center",
  fontFamily: "inherit",
  color: _.offBlack,
  background: "#FFFFFF",
  border: `1px solid ${_.grayLight}`,
  borderRadius: "12px"
}, children: [h("svg", { width: "32", height: "32", viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true", children: h("path", { d: "M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z", stroke: _.evergreen, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }), h("p", { style: { margin: 0, fontSize: "16px", fontWeight: 600 }, children: "Something went wrong" }), h("p", { style: { margin: 0, fontSize: "14px", opacity: 0.75 }, children: "We couldn't load this content. Please check your internet connection and try again." }), h("button", { type: "button", onClick: e, style: {
  marginTop: "8px",
  padding: "8px 20px",
  fontSize: "14px",
  fontWeight: 600,
  fontFamily: "inherit",
  color: _.green,
  background: _.evergreen,
  border: "none",
  borderRadius: "8px",
  cursor: "pointer"
}, children: "Try again" })] }), D = (e, t) => {
  z(() => {
    const o = e.current;
    if (o)
      for (const [n, r] of Object.entries(t))
        r !== void 0 && (o[n] = r);
  });
}, P = {
  dev: "https://grafana-faro-collector.dev.0hash.com/collect",
  cert: "https://grafana-faro-collector.cert.zerohash.com/collect",
  prod: "https://grafana-faro-collector.zerohash.com/collect",
  "eu-cert": "https://grafana-faro-collector.cert.zerohash.eu/collect",
  "eu-prod": "https://grafana-faro-collector.zerohash.eu/collect",
  sandbox: "https://grafana-faro-collector.cert.zerohash.com/collect",
  production: "https://grafana-faro-collector.zerohash.com/collect"
}, J = (e) => {
  if (!e || typeof e != "string")
    return null;
  const t = e.split(".");
  if (t.length < 2)
    return null;
  try {
    const o = t[1].replace(/-/g, "+").replace(/_/g, "/"), n = o + "===".slice(0, (4 - o.length % 4) % 4), r = typeof atob < "u" ? atob(n) : Buffer.from(n, "base64").toString("utf-8"), c = JSON.parse(r)?.payload?.region;
    if (typeof c != "string")
      return null;
    const a = c.toLowerCase();
    return a === "us" || a === "eu" ? a : null;
  } catch {
    return null;
  }
}, B = (e, t) => J(t) !== "eu" ? e : e === "cert" ? "eu-cert" : e === "prod" ? "eu-prod" : e, $ = (e) => {
  if (!e || typeof e != "string")
    return {};
  const t = e.split(".");
  if (t.length < 2)
    return {};
  try {
    const o = t[1].replace(/-/g, "+").replace(/_/g, "/"), n = o + "===".slice(0, (4 - o.length % 4) % 4), r = typeof atob < "u" ? atob(n) : Buffer.from(n, "base64").toString("utf-8"), i = JSON.parse(r), c = i?.payload ?? {}, a = (s) => typeof s == "string" && s.length > 0 ? s : void 0;
    return {
      participantCode: a(c.participant_code),
      platformName: a(c.platform_name),
      platformCode: a(i.platform_code),
      region: a(c.region)
    };
  } catch {
    return {};
  }
}, F = (e, t, o) => {
  const n = B(t, o);
  return e[n] ?? e[t] ?? e.prod;
}, K = (e, t, o) => {
  const n = B(t, o);
  return e[n] ?? e[t];
}, v = () => {
}, H = () => {
  const e = new Uint8Array(8);
  return globalThis.crypto.getRandomValues(e), Array.from(e, (t) => t.toString(16).padStart(2, "0")).join("");
}, G = (e, t) => {
  const o = H(), n = globalThis.__ZH_WEB_SDK_VERSION__, r = {};
  e.claims.participantCode && (r.participant_code = e.claims.participantCode), e.claims.platformName && (r.platform_name = e.claims.platformName), e.claims.platformCode && (r.platform_code = e.claims.platformCode), e.claims.region && (r.region = e.claims.region), n && (r.zh_web_sdk_version = n);
  const i = {
    meta: {
      app: { name: e.appName, version: t ?? "unknown", environment: e.env },
      session: { id: o, attributes: r },
      browser: typeof navigator < "u" ? { userAgent: navigator.userAgent } : void 0,
      page: typeof window < "u" ? { url: window.location.origin } : void 0
    },
    logs: [
      {
        message: `Failed to load the script for ${e.webComponentTag} from ${e.env} environment.`,
        level: "error",
        timestamp: (/* @__PURE__ */ new Date()).toISOString(),
        context: {
          web_component: e.webComponentTag,
          script_url: e.scriptUrl,
          reason: e.reason,
          tried_fallback: String(e.triedFallback),
          elapsed_ms: String(e.elapsedMs)
        }
      }
    ]
  };
  return { sessionId: o, payload: i };
}, Z = (e, t, o) => {
  if (!e || typeof fetch > "u")
    return;
  const { sessionId: n, payload: r } = G(t, o);
  try {
    fetch(e, {
      method: "POST",
      headers: { "Content-Type": "application/json", "x-faro-session-id": n },
      body: JSON.stringify(r),
      keepalive: !0
    }).catch(() => {
    });
  } catch {
  }
}, q = (e) => {
  const { webComponentTag: t, appName: o, appVersion: n, scriptUrls: r, fallbackScriptUrls: i, collectorUrls: c, env: a, jwt: s, timeoutMs: p = 15e3, onLoad: y, onError: f } = e;
  if (typeof document > "u")
    return v;
  const m = `${t}-script-${a}`;
  if (customElements.get(t) || document.getElementById(m))
    return v;
  const R = $(s), S = e.report ?? ((d) => Z(c && K(c, a, s), d, n));
  let u = !1, w = 0, x;
  const b = () => {
    x !== void 0 && clearTimeout(x);
  }, C = (d, g, l) => {
    if (u)
      return;
    const U = Math.round(performance.now() - w), k = {
      webComponentTag: t,
      appName: o,
      env: a,
      scriptUrl: g,
      reason: d,
      triedFallback: l,
      elapsedMs: U,
      claims: R
    };
    S(k);
    const E = l ? void 0 : F(i ?? {}, a, s);
    if (E && E !== g) {
      O(E, !0);
      return;
    }
    u = !0, b(), document.getElementById(m)?.remove(), f?.(k);
  }, O = (d, g) => {
    b(), w = performance.now();
    const l = document.createElement("script");
    l.id = m, l.src = d, l.type = "module", l.async = !0, l.onload = () => {
      setTimeout(() => {
        u || (customElements.get(t) ? (u = !0, b(), y?.()) : C("not-defined", d, g));
      }, 0);
    }, l.onerror = () => C("network", d, g), x = setTimeout(() => C("timeout", d, g), p), document.getElementById(m)?.remove(), document.head.appendChild(l);
  }, T = F(r, a, s);
  return T ? (O(T, !1), () => {
    u = !0, b();
  }) : v;
};
var L;
(function(e) {
  e.NETWORK_ERROR = "network_error", e.AUTH_ERROR = "auth_error", e.NOT_FOUND_ERROR = "not_found_error", e.VALIDATION_ERROR = "validation_error", e.SERVER_ERROR = "server_error", e.CLIENT_ERROR = "client_error", e.UNKNOWN_ERROR = "unknown_error";
})(L || (L = {}));
const Q = (e) => {
  const { webComponentTag: t, appName: o, appVersion: n, scriptUrls: r, fallbackScriptUrls: i, collectorUrls: c, env: a, jwt: s, timeoutMs: p } = e, [y, f] = N(!1), [m, R] = N(0);
  z(() => (f(!1), q({
    webComponentTag: t,
    appName: o ?? t,
    appVersion: n,
    scriptUrls: r,
    fallbackScriptUrls: i,
    collectorUrls: c ?? P,
    env: a,
    jwt: s,
    timeoutMs: p,
    onError: () => f(!0)
  })), [
    t,
    o,
    n,
    r,
    i,
    c,
    a,
    s,
    p,
    m
  ]);
  const S = j(() => R((u) => u + 1), []);
  return { loadFailed: y, retry: S };
}, X = {
  sandbox: "https://sdk.sandbox.connect.xyz/auth-web/index.js",
  production: "https://sdk.connect.xyz/auth-web/index.js"
}, I = "connect-auth", Y = X, oe = ({
  jwt: e,
  env: t = "production",
  theme: o,
  onError: n,
  onClose: r,
  onDeposit: i,
  onEvent: c,
  onLoaded: a,
  ...s
}) => {
  const p = M(null);
  D(p, { theme: o, onError: n, onClose: r, onDeposit: i, onEvent: c, onLoaded: a });
  const { loadFailed: y, retry: f } = Q({
    webComponentTag: I,
    scriptUrls: Y,
    env: t,
    jwt: e
  });
  return y ? /* @__PURE__ */ h(V, { onRetry: f }) : W.createElement(I, {
    ref: p,
    jwt: e,
    env: t,
    theme: o,
    ...s
  });
};
export {
  oe as Auth
};
